var _path, _rect, _rect2, _g, _rect3, _rect4, _rect5, _path2, _path3, _path4, _path5, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToastAddRaydiant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246,
    height: 158,
    viewBox: "0 0 246 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M237.487 120.25C222.293 142.978 186.296 148.237 161.055 152.297C135.834 156.127 121.493 158.652 94.9156 157.852C68.3379 157.052 29.5424 152.696 11.6295 128.281C-6.30242 104.097 -3.33279 59.6233 19.4015 40.9915C41.9057 22.3406 84.3181 29.1957 124.5 29.3793C164.787 29.6874 203.075 23.3431 224.96 40.3231C246.95 57.4277 252.682 97.5208 237.487 120.25Z",
    fill: "#CAF2ED"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 1,
    width: 164.434,
    height: 111.163,
    rx: 6,
    fill: "#F7F7F7",
    stroke: "#F7F7F7",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_133_28577",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 2,
    width: 163,
    height: 110
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42.2396,
    y: 2,
    width: 162.434,
    height: 109.163,
    rx: 4.36652,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_133_28577)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.2396,
    y: -8,
    width: 182.434,
    height: 129.163,
    fill: "#F7F7F7",
    stroke: "black",
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.7396,
    y: -15.5,
    width: 197.434,
    height: 144.163,
    fill: "#F7F7F7",
    stroke: "white",
    strokeWidth: 35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.2396,
    y: 2,
    width: 162.434,
    height: 14.8462,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.2396,
    y: 2,
    width: 162.434,
    height: 14.8462,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.0859,
    y: 2,
    width: 109.163,
    height: 14.8461,
    transform: "rotate(90 57.0859 2)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.0859,
    y: 2,
    width: 109.163,
    height: 14.8461,
    transform: "rotate(90 57.0859 2)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.2396,
    y: 2,
    width: 14.8462,
    height: 14.8462,
    fill: "#FF4C00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.2396,
    y: 2,
    width: 14.8462,
    height: 14.8462,
    fill: "#FF4C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5511 10.8371C53.5579 10.3273 53.5358 9.81749 53.4849 9.31116C53.4475 8.969 53.3337 8.53007 52.9684 8.44021C53.0155 8.45235 53.065 8.45055 53.1111 8.43503C53.5341 8.21038 53.5019 7.65566 53.3524 7.25475C53.1553 6.72941 52.688 6.35615 52.2242 6.10903C51.364 5.67276 50.4101 5.46239 49.4495 5.4971C48.4888 5.53181 47.552 5.8105 46.7244 6.30776C46.3048 6.57043 45.8222 7.08367 46.0346 7.65566C46.0922 7.79801 46.1771 7.92726 46.2844 8.03584L46.4441 8.20519C46.2283 8.50242 46.0703 8.772 45.9684 9.13317C45.6625 10.2219 45.7135 10.9217 45.7967 11.7961C45.8494 12.337 46.0244 13.1423 46.6378 13.2322C47.1373 13.303 47.6793 13.1354 48.1788 13.0749C48.7293 13.0092 49.2849 12.9056 49.8421 12.9211C50.6271 12.9419 51.4053 13.1302 52.1919 13.1389C52.6065 13.1423 53.2963 13.1838 53.4203 12.6273C53.5375 12.0985 53.5426 11.549 53.5426 11.0099C53.5494 10.9528 53.5494 10.8941 53.5494 10.8388L53.5511 10.8371ZM52.654 11.7512C52.4587 12.1988 51.9065 12.1487 51.5208 12.1158L49.7963 11.9067C49.2832 11.8912 48.7752 11.9897 48.2756 12.102C47.9019 12.185 47.3802 12.4044 47.0421 12.1124C46.6667 11.7892 46.6004 11.238 46.5953 10.7731C46.6024 10.3534 46.6433 9.93492 46.7176 9.52199C46.7635 9.26623 46.8383 9.01739 46.9368 8.77891C47.071 8.4333 47.2698 8.2242 47.28 8.23457C47.1798 8.12916 47.0591 8.07213 46.9912 7.9287C46.7346 7.38435 47.3752 6.92296 47.7252 6.7657C48.9502 6.20926 50.6628 6.26456 51.8198 6.97826C52.18 7.20118 52.88 7.96672 52.2259 8.34862C52.6286 8.54217 52.7322 9.12626 52.7764 9.54099C52.847 10.2071 52.8265 10.88 52.7152 11.5404C52.7032 11.6131 52.6838 11.6839 52.654 11.7512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5511 10.8371C53.5579 10.3273 53.5358 9.81749 53.4849 9.31116C53.4475 8.969 53.3337 8.53007 52.9684 8.44021C53.0155 8.45235 53.065 8.45055 53.1111 8.43503C53.5341 8.21038 53.5019 7.65566 53.3524 7.25475C53.1553 6.72941 52.688 6.35615 52.2242 6.10903C51.364 5.67276 50.4101 5.46239 49.4495 5.4971C48.4888 5.53181 47.552 5.8105 46.7244 6.30776C46.3048 6.57043 45.8222 7.08367 46.0346 7.65566C46.0922 7.79801 46.1771 7.92726 46.2844 8.03584L46.4441 8.20519C46.2283 8.50242 46.0703 8.772 45.9684 9.13317C45.6625 10.2219 45.7135 10.9217 45.7967 11.7961C45.8494 12.337 46.0244 13.1423 46.6378 13.2322C47.1373 13.303 47.6793 13.1354 48.1788 13.0749C48.7293 13.0092 49.2849 12.9056 49.8421 12.9211C50.6271 12.9419 51.4053 13.1302 52.1919 13.1389C52.6065 13.1423 53.2963 13.1838 53.4203 12.6273C53.5375 12.0985 53.5426 11.549 53.5426 11.0099C53.5494 10.9528 53.5494 10.8941 53.5494 10.8388L53.5511 10.8371ZM52.654 11.7512C52.4587 12.1988 51.9065 12.1487 51.5208 12.1158L49.7963 11.9067C49.2832 11.8912 48.7752 11.9897 48.2756 12.102C47.9019 12.185 47.3802 12.4044 47.0421 12.1124C46.6667 11.7892 46.6004 11.238 46.5953 10.7731C46.6024 10.3534 46.6433 9.93492 46.7176 9.52199C46.7635 9.26623 46.8383 9.01739 46.9368 8.77891C47.071 8.4333 47.2698 8.2242 47.28 8.23457C47.1798 8.12916 47.0591 8.07213 46.9912 7.9287C46.7346 7.38435 47.3752 6.92296 47.7252 6.7657C48.9502 6.20926 50.6628 6.26456 51.8198 6.97826C52.18 7.20118 52.88 7.96672 52.2259 8.34862C52.6286 8.54217 52.7322 9.12626 52.7764 9.54099C52.847 10.2071 52.8265 10.88 52.7152 11.5404C52.7032 11.6131 52.6838 11.6839 52.654 11.7512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.0181,
    y: 36.9321,
    width: 103.05,
    height: 62.8778,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.0181,
    y: 36.9321,
    width: 103.05,
    height: 62.8778,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.819,
    y: 37.8057,
    width: 20.9593,
    height: 5.23982,
    fill: "#FF4C00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.819,
    y: 37.8057,
    width: 20.9593,
    height: 5.23982,
    fill: "#FF4C00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.751,
    y: 44.792,
    width: 52.3982,
    height: 5.23982,
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.751,
    y: 44.792,
    width: 52.3982,
    height: 5.23982,
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.751,
    y: 51.7783,
    width: 34.0588,
    height: 2.61991,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.751,
    y: 51.7783,
    width: 34.0588,
    height: 2.61991,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.751,
    y: 70.1179,
    width: 34.0588,
    height: 2.61991,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.751,
    y: 70.1179,
    width: 34.0588,
    height: 2.61991,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.751,
    y: 88.4573,
    width: 34.0588,
    height: 2.61991,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.751,
    y: 88.4573,
    width: 34.0588,
    height: 2.61991,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.751,
    y: 63.1313,
    width: 41.9186,
    height: 5.23982,
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.751,
    y: 63.1313,
    width: 41.9186,
    height: 5.23982,
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.751,
    y: 81.4707,
    width: 62.8778,
    height: 5.23982,
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.751,
    y: 81.4707,
    width: 62.8778,
    height: 5.23982,
    fill: "#CFCFCF"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 69.2444,
    width: 27.0724,
    height: 27.0724,
    rx: 6.98642,
    fill: "#FCE8E5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38.7465,
    y: 74.4844,
    width: 20.086,
    height: 18.5409,
    fill: "url(#pattern0_133_28577)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 183.715,
    y: 26.4529,
    width: 46.2851,
    height: 46.2851,
    rx: 6.98642,
    fill: "#0047D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M205.229 36.9321C198.653 36.9321 193.321 42.2642 193.321 48.8399H205.229V36.9321Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M218.331 51.2217H207.611V52.4125C207.611 58.3327 212.41 63.1295 218.328 63.1295H219.519V52.4125C219.519 51.7546 218.986 51.2217 218.328 51.2217H218.331Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M193.321 61.9411C193.321 62.5989 193.854 63.1319 194.512 63.1319H204.038C204.696 63.1319 205.229 62.5989 205.229 61.9411V51.2217H193.321V61.9387V61.9411Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M219.52 42.886C219.52 39.597 216.856 36.9321 213.567 36.9321H207.613V48.8399H213.567C216.856 48.8399 219.52 46.1751 219.52 42.886Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_133_28577",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_133_28577",
    transform: "matrix(0.0192308 0 0 0.0208333 0.0739213 -0.00308006)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_133_28577",
    width: 64,
    height: 48,
    xlinkHref: "data:image/png;base64,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"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastAddRaydiant);
export default __webpack_public_path__ + "static/media/toast-add-raydiant.b73189ea6d67d74ae3962b388822e20c.svg";
export { ForwardRef as ReactComponent };